<template>
  <div style="padding: 5px">
    <div class="print-break-after">
      <!-- CLIENTE -->
      <div class="vertical-height-div" style="height: 10px"></div>
      <div class="wg-row" style="align-items: center">
        <div
          :class="[
            'wg-col',
            mode === 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          {{ $anm22.strLang(lang, "Customer name", "Nome cliente") }}
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-7' : 'wg-xs-12 wg-md-7 wg-sm-7',
          ]"
        >
          <input
            disabled
            class="com-anm22-app-input-text"
            type="text"
            :value="
              customer ? customer.firstName + ' ' + customer.lastName : ''
            "
          />
        </div>
      </div>
      <!-- PROGETTO -->
      <div class="vertical-height-div" style="height: 10px"></div>
      <div class="wg-row" style="align-items: center">
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          {{ $anm22.strLang(lang, "Project", "Progetto") }}
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-7' : 'wg-xs-12 wg-md-7 wg-sm-7',
          ]"
        >
          <input
            disabled
            class="com-anm22-app-input-text"
            type="text"
            :value="projectName"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height: 10px"></div>
      <div class="wg-row" style="align-items: center">
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          {{ $anm22.strLang(lang, "Order", "Commessa") }}
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-7' : 'wg-xs-12 wg-md-7 wg-sm-7',
          ]"
        >
          <input
            disabled
            class="com-anm22-app-input-text"
            type="text"
            :value="details.order"
          />
        </div>
      </div>
      <!-- AGENTE -->
      <!--<div class="vertical-height-div" style="height: 10px"></div>
      <div class="wg-row" style="align-items: center">
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          {{ $anm22.strLang(lang, "Agent", "Agente") }}
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-7' : 'wg-xs-12 wg-md-7 wg-sm-7',
          ]"
        >
          <input
            disabled
            class="com-anm22-app-input-text"
            type="text"
            :value="details.agentName"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height: 10px"></div>
      <div class="wg-row" style="align-items: center">
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          {{ $anm22.strLang(lang, "Subagent", "Subagente") }}
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-7' : 'wg-xs-12 wg-md-7 wg-sm-7',
          ]"
        >
          <input
            disabled
            class="com-anm22-app-input-text"
            type="text"
            :value="details.subAgentName?details.subAgentName:''"
          />
        </div>
      </div>-->
      <div class="vertical-height-div" style="height: 25px"></div>
      <div
        class="wg-row"
        style="
          align-items: center;
          justify-content: space-between;
          text-align: center;
        "
      >
        <div class="wg-col wg-xs-12 wg-md-12 wg-sm-12">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "RECEIVING SIGNED ORDER CONFIRMATION", "RICEZIONE CONFERMA ORDINE FIRMATA") }}
          </div>
        </div>
        <div class="vertical-height-div" style="height: 10px"></div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Expected date", "Data prevista") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-date"
            type="date"
            :disabled="mode === 'view'"
            v-model="expectedReceivingConfirmationDate"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
          />
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Real date", "Data reale") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-date"
            type="date"
            :disabled="mode === 'view'"
            v-model="realReceivingConfirmationDate"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
          />
        </div>

        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-4' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Notes", "Note") }}
          </div>
          <input
            type="text"
            :disabled="mode === 'view'"
            v-model="operativeDetails.receivingConfNotes"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height: 25px"></div>
      <div
        class="wg-row"
        style="
          align-items: center;
          justify-content: space-between;
          text-align: center;
        "
      >
        <div class="wg-col wg-xs-12 wg-md-12 wg-sm-12">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "PAYMENT IN ADVANCE ISSUE L / C", "PAGAMENTO ANTICIPO EMISSIONE L/C") }}
          </div>
        </div>
        <div class="vertical-height-div" style="height: 10px"></div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Expected date", "Data prevista") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-date"
            type="date"
            :disabled="mode === 'view'"
            v-model="expectedPaymentEmissionDate"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
          />
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Real date", "Data reale") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-date"
            type="date"
            :disabled="mode === 'view'"
            v-model="realPaymentEmissionDate"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
          />
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-4' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Notes", "Note") }}
          </div>
          <input
            type="text"
            :disabled="mode === 'view'"
            v-model="operativeDetails.paymentEmissionNotes"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height: 25px"></div>
      <div
        class="wg-row"
        style="
          align-items: center;
          justify-content: space-between;
          text-align: center;
        "
      >
        <div class="wg-col wg-xs-12 wg-md-12 wg-sm-12">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "DRAWING APPROVAL", "APPROVAZIONE DISEGNO") }}
          </div>
        </div>
        <div class="vertical-height-div" style="height: 10px"></div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Expected date", "Data prevista") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-date"
            type="date"
            :disabled="mode === 'view'"
            v-model="expectedDrawingDate"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
          />
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Real date", "Data reale") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-date"
            type="date"
            :disabled="mode === 'view'"
            v-model="realDrawingDate"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
          />
        </div>

        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-4' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Notes", "Note") }}
          </div>
          <input
            type="text"
            :disabled="mode === 'view'"
            v-model="operativeDetails.drawingNotes"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height: 25px"></div>
      <div
        class="wg-row"
        style="
          align-items: center;
          justify-content: space-between;
          text-align: center;
        "
      >
        <div class="wg-col wg-xs-12 wg-md-12 wg-sm-12">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "BAGS SIZES", "DIMENSIONE SACCHI") }}
          </div>
        </div>
        <div class="vertical-height-div" style="height: 10px"></div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Expected date", "Data prevista") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-date"
            type="date"
            :disabled="mode === 'view'"
            v-model="expectedBagsSizeDate"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
          />
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Real date", "Data reale") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-date"
            type="date"
            :disabled="mode === 'view'"
            v-model="realBagsSizeDate"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
          />
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-4' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Notes", "Note") }}
          </div>
          <input
            type="text"
            :disabled="mode === 'view'"
            v-model="operativeDetails.bagsSizeNotes"
          />
        </div>
      </div>

      <div class="vertical-height-div" style="height: 25px"></div>
      <div
        class="wg-row"
        style="
          align-items: center;
          justify-content: space-between;
          text-align: center;
        "
      >
        <div class="wg-col wg-xs-12 wg-md-12 wg-sm-12">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "SACKS SAMPLES", "CAMPIONI SACCHI") }}
          </div>
        </div>
        <div class="vertical-height-div" style="height: 10px"></div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Expected date", "Data prevista") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-date"
            type="date"
            :disabled="mode === 'view'"
            v-model="expectedSacksSamplesDate"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
          />
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Real date", "Data reale") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-date"
            type="date"
            :disabled="mode === 'view'"
            v-model="realSacksSamplesDate"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
          />
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-4' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Notes", "Note") }}
          </div>
          <input
            type="text"
            :disabled="mode === 'view'"
            v-model="operativeDetails.sacksSamplesNotes"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height: 25px"></div>
      <div
        class="wg-row"
        style="
          align-items: center;
          justify-content: space-between;
          text-align: center;
        "
      >
        <div class="wg-col wg-xs-12 wg-md-12 wg-sm-12">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "ORDER EMISSION DATE", "DATA EMISSIONE ORDINE") }}
          </div>
        </div>
        <div class="vertical-height-div" style="height: 10px"></div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Expected date", "Data prevista") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-date"
            type="date"
            :disabled="mode === 'view'"
            v-model="expectedOrderEmissionDate"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
          />
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Real date", "Data reale") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-date"
            type="date"
            :disabled="mode === 'view'"
            v-model="realOrderEmissionDate"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
          />
        </div>

        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-4' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Notes", "Note") }}
          </div>
          <input
            type="text"
            :disabled="mode === 'view'"
            v-model="operativeDetails.orderEmissionNotes"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height: 25px"></div>
      <div
        class="wg-row"
        style="
          align-items: center;
          justify-content: space-between;
          text-align: center;
        "
      >
        <div class="wg-col wg-xs-12 wg-md-12 wg-sm-12">
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, "CONTRACTUAL DELIVERY", "CONSEGNA CONTRATTUALE") }}
          </div>
        </div>
        <div class="vertical-height-div" style="height: 10px"></div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-2' : 'wg-xs-12 wg-md-2 wg-sm-2',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Contractual", "Contrattuale") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-date"
            type="date"
            disabled
            v-model="expectedDelivery"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
          />
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-2' : 'wg-xs-12 wg-md-2 wg-sm-2',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Programmed", "Programmata") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-date"
            type="date"
            disabled
            v-model="programmedDeliveryDate"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
          />
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-2' : 'wg-xs-12 wg-md-2 wg-sm-2',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Real", "Reale") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-date"
            type="date"
            :disabled="mode === 'view'"
            v-model="realDeliveryDate"
            :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
          />
        </div>
        <div
          :class="[
            'wg-col',
            mode == 'view' ? 'wg-xs-3' : 'wg-xs-12 wg-md-3 wg-sm-3',
          ]"
        >
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Notes", "Note") }}
          </div>
          <input
            type="text"
            :disabled="mode === 'view'"
            v-model="operativeDetails.deliveryNotes"
          />
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height: 25px"></div>
    <div
      class="wg-row"
      style="
        align-items: center;
        justify-content: space-between;
        text-align: center;
      "
    >
      <div class="wg-col wg-xs-12 wg-md-12 wg-sm-12">
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, "CREDIT LETTER", "LETTERA DI CREDITO") }}
        </div>
      </div>
      <div class="vertical-height-div" style="height: 10px"></div>
      <div
        :class="[
          'wg-col',
          mode == 'view' ? 'wg-xs-1' : 'wg-xs-12 wg-md-3 wg-sm-3',
        ]"
      >
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Yes", "Si") }}
        </div>
        <input
          id="confirmed"
          type="checkbox"
          :value="1"
          :disabled="mode === 'view'"
          v-model="operativeDetails.creditLetter"
          style="display: none"
        />
        <label class="label-input-radio" for="confirmed">{{
          operativeDetails.creditLetter ? "✔" : ""
        }}</label>
      </div>
      <div
        :class="[
          'wg-col',
          mode == 'view' ? 'wg-xs-1' : 'wg-xs-12 wg-md-3 wg-sm-3',
        ]"
      >
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "No", "No") }}
        </div>
        <input
          id="confirmed"
          type="checkbox"
          :disabled="mode === 'view'"
          :value="0"
          style="display: none"
          v-model="operativeDetails.creditLetter"
        />
        <label class="label-input-radio" for="confirmed">{{
          !operativeDetails.creditLetter ? "✔" : ""
        }}</label>
      </div>
      <div
        :class="[
          'wg-col',
          mode == 'view' ? 'wg-xs-2' : 'wg-xs-12 wg-md-2 wg-sm-2',
        ]"
      >
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Last sped. date", "Data ultima sped.") }}
        </div>
        <input
          class="input-elem com-anm22-app-input-date"
          type="date"
          :disabled="mode === 'view'"
          v-model="lastSpeditionDate"
          :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
        />
      </div>
      <div
        :class="[
          'wg-col',
          mode == 'view' ? 'wg-xs-4' : 'wg-xs-12 wg-md-3 wg-sm-3',
        ]"
      >
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Notes", "Note") }}
        </div>
        <input
          type="text"
          :disabled="mode === 'view'"
          v-model="operativeDetails.letterCreditNotes"
        />
      </div>
    </div>
    <div class="vertical-height-div" style="height: 25px"></div>
    <div
      class="wg-row"
      style="
        align-items: center;
        justify-content: space-between;
        text-align: center;
      "
    >
      <div class="wg-col wg-xs-12 wg-md-12 wg-sm-12">
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, "PENALTIES", "PENALI") }}
        </div>
      </div>
      <div class="vertical-height-div" style="height: 10px"></div>
      <div
        :class="[
          'wg-col',
          mode == 'view' ? 'wg-xs-1' : 'wg-xs-12 wg-md-3 wg-sm-3',
        ]"
      >
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Yes", "Si") }}
        </div>
        <input
          id="penal"
          type="checkbox"
          :disabled="mode === 'view'"
          :value="1"
          v-model="operativeDetails.penal"
          style="display: none"
        />
        <label class="label-input-radio" for="penal">{{
          operativeDetails.penal ? "✔" : ""
        }}</label>
      </div>
      <div
        :class="[
          'wg-col',
          mode == 'view' ? 'wg-xs-1' : 'wg-xs-12 wg-md-3 wg-sm-3',
        ]"
      >
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "No", "No") }}
        </div>
        <input
          id="penal"
          type="checkbox"
          :disabled="mode === 'view'"
          :value="0"
          v-model="operativeDetails.penal"
          style="display: none"
        />
        <label class="label-input-radio" for="penal">{{
          !operativeDetails.penal ? "✔" : ""
        }}</label>
      </div>
      <div
        :class="[
          'wg-col',
          mode == 'view' ? 'wg-xs-2' : 'wg-xs-12 wg-md-2 wg-sm-2',
        ]"
      >
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Application date", "Data applicazione") }}
        </div>
        <input
          class="input-elem com-anm22-app-input-date"
          type="date"
          :disabled="mode === 'view'"
          v-model="penalApplicationDate"
          :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
        />
      </div>
      <div
        :class="[
          'wg-col',
          mode == 'view' ? 'wg-xs-4' : 'wg-xs-12 wg-md-3 wg-sm-3',
        ]"
      >
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Notes", "Note") }}
        </div>
        <input
          type="text"
          :disabled="mode === 'view'"
          v-model="operativeDetails.penalNotes"
        />
      </div>
      <div class="vertical-height-div" style="height: 20px"></div>
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Last edit", "Ultima modifica") }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height: 10px"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ lastEditDate + " " + lastEditUser }}
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height: 10px"></div>
      <div v-if="mode == 'edit'" class="wg-row" style="padding: 5px">
        <input
          type="button"
          :value="$anm22.strLang(lang, 'Save', 'Salva')"
          @click="saveForm"
        />
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <paglierani-widget-history
          :projectId="project.idWorldProject"></paglierani-widget-history>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PaglieraniWidgetHistory from "./PaglieraniWidgetHistory.vue"

export default {
  components: {
    PaglieraniWidgetHistory
  },
  props: {
    projectId: [Number, String],
    docs: Object,
    mode: {
      type: String,
      default: "edit",
    },
  },
  data() {
    return {
      newContactMode: false,
      customer: {},
      details: {
        contracts: [],
      },
      operativeDetails: [],
      contrs: [],
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      windowWidth: (state) => state.windowWidth,
    }),
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.operativeDetails.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.operativeDetails.lastUpdate
        ? this.$moment.unix(this.operativeDetails.lastUpdate).format("DD/MM/YYYY HH:mm")
        : "";
    },
    projectName() {
      let projectName = "";
      projectName +=
        this.project.projectId !== "" ? this.project.projectId : "";
      projectName += this.project.projectId !== "" ? "-" : "";
      projectName += this.project.name !== "" ? this.project.name : "";
      return projectName;
    },
    expectedReceivingConfirmationDate: {
      get() {
        if (this.operativeDetails.expectedReceivingConfirmationDate) {
          return this.$moment
            .unix(this.operativeDetails.expectedReceivingConfirmationDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.operativeDetails.expectedReceivingConfirmationDate = "";
        } else if (ts) {
          this.operativeDetails.expectedReceivingConfirmationDate = ts;
        }
      }, 2000),
    },
    realReceivingConfirmationDate: {
      get() {
        if (this.operativeDetails.realReceivingConfirmationDate) {
          return this.$moment
            .unix(this.operativeDetails.realReceivingConfirmationDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.operativeDetails.realReceivingConfirmationDate = "";
        } else if (ts) {
          this.operativeDetails.realReceivingConfirmationDate = ts;
        }
      }, 2000),
    },
    expectedPaymentEmissionDate: {
      get() {
        if (this.operativeDetails.expectedPaymentEmissionDate) {
          return this.$moment
            .unix(this.operativeDetails.expectedPaymentEmissionDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.operativeDetails.expectedPaymentEmissionDate = "";
        } else if (ts) {
          this.operativeDetails.expectedPaymentEmissionDate = ts;
        }
      }, 2000),
    },
    realPaymentEmissionDate: {
      get() {
        if (this.operativeDetails.realPaymentEmissionDate) {
          return this.$moment
            .unix(this.operativeDetails.realPaymentEmissionDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.operativeDetails.realPaymentEmissionDate = "";
        } else if (ts) {
          this.operativeDetails.realPaymentEmissionDate = ts;
        }
      }, 2000),
    },
    expectedDrawingDate: {
      get() {
        if (this.operativeDetails.expectedDrawingDate) {
          return this.$moment
            .unix(this.operativeDetails.expectedDrawingDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.operativeDetails.expectedDrawingDate = "";
        } else if (ts) {
          this.operativeDetails.expectedDrawingDate = ts;
        }
      }, 2000),
    },
    realDrawingDate: {
      get() {
        if (this.operativeDetails.realDrawingDate) {
          return this.$moment
            .unix(this.operativeDetails.realDrawingDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.operativeDetails.realDrawingDate = "";
        } else if (ts) {
          this.operativeDetails.realDrawingDate = ts;
        }
      }, 2000),
    },
    expectedBagsSizeDate: {
      get() {
        if (this.operativeDetails.expectedBagsSizeDate) {
          return this.$moment
            .unix(this.operativeDetails.expectedBagsSizeDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.operativeDetails.expectedBagsSizeDate = "";
        } else if (ts) {
          this.operativeDetails.expectedBagsSizeDate = ts;
        }
      }, 2000),
    },
    realBagsSizeDate: {
      get() {
        if (this.operativeDetails.realBagsSizeDate) {
          return this.$moment
            .unix(this.operativeDetails.realBagsSizeDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.operativeDetails.realBagsSizeDate = "";
        } else if (ts) {
          this.operativeDetails.realBagsSizeDate = ts;
        }
      }, 2000),
    },
    expectedSacksSamplesDate: {
      get() {
        if (this.operativeDetails.expectedSacksSamplesDate) {
          return this.$moment
            .unix(this.operativeDetails.expectedSacksSamplesDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.operativeDetails.expectedSacksSamplesDate = "";
        } else if (ts) {
          this.operativeDetails.expectedSacksSamplesDate = ts;
        }
      }, 2000),
    },
    realSacksSamplesDate: {
      get() {
        if (this.operativeDetails.realSacksSamplesDate) {
          return this.$moment
            .unix(this.operativeDetails.realSacksSamplesDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.operativeDetails.realSacksSamplesDate = "";
        } else if (ts) {
          this.operativeDetails.realSacksSamplesDate = ts;
        }
      }, 2000),
    },
    expectedOrderEmissionDate: {
      get() {
        if (this.operativeDetails.expectedOrderEmissionDate) {
          return this.$moment
            .unix(this.operativeDetails.expectedOrderEmissionDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.operativeDetails.expectedOrderEmissionDate = "";
        } else if (ts) {
          this.operativeDetails.expectedOrderEmissionDate = ts;
        }
      }, 2000),
    },
    realOrderEmissionDate: {
      get() {
        if (this.operativeDetails.realOrderEmissionDate) {
          return this.$moment
            .unix(this.operativeDetails.realOrderEmissionDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.operativeDetails.realOrderEmissionDate = "";
        } else if (ts) {
          this.operativeDetails.realOrderEmissionDate = ts;
        }
      }, 2000),
    },
    expectedDelivery: {
      get() {
        if (this.details.expectedDelivery) {
          return this.$moment
            .unix(this.details.expectedDelivery)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.details.expectedDelivery = "";
        } else if (ts) {
          this.details.expectedDelivery = ts;
        }
      }, 2000),
    },
    realDeliveryDate: {
      get() {
        if (this.operativeDetails.realDeliveryDate) {
          return this.$moment
            .unix(this.operativeDetails.realDeliveryDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.operativeDetails.realDeliveryDate = "";
        } else if (ts) {
          this.operativeDetails.realDeliveryDate = ts;
        }
      }, 2000),
    },
    programmedDeliveryDate: {
      get() {
        if (this.details.realDelivery) {
          return this.$moment
            .unix(this.details.realDelivery)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.details.realDelivery = "";
        } else if (ts) {
          this.details.realDelivery = ts;
        }
      }, 2000),
    },
    lastSpeditionDate: {
      get() {
        if (this.operativeDetails.lastSpeditionDate) {
          return this.$moment
            .unix(this.operativeDetails.lastSpeditionDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.operativeDetails.lastSpeditionDate = "";
        } else if (ts) {
          this.operativeDetails.lastSpeditionDate = ts;
        }
      }, 2000),
    },
    penalApplicationDate: {
      get() {
        if (this.operativeDetails.penalApplicationDate) {
          return this.$moment
            .unix(this.operativeDetails.penalApplicationDate)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.operativeDetails.penalApplicationDate = "";
        } else if (ts) {
          this.operativeDetails.penalApplicationDate = ts;
        }
      }, 2000),
    },
    project() {
      return this.$store.getters["projects/get"]([this.projectId]);
    },
  },
  methods: {
    saveForm() {
      const docs = { ...this.docs };
      docs.operativeDetails = this.operativeDetails;
      docs.operativeDetails.lastUser = this.user.idWorldUser;
      docs.operativeDetails.lastUpdate = this.$moment().unix();
      this.$emit("canUpdateProject", true);
      this.$emit("save", docs);
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
  },
  created() {
    if (this.project.customers.length > 0) {
      this.customer = {
        ...this.$store.getters["contacts/get"](this.project.customers[0]),
      };
    } else {
      this.customer = null;
    }
    //Array commessa
    this.details = { ...this.docs.details };
    this.operativeDetails = { ...this.docs.operativeDetails };
    if (!this.details.contracts) {
      this.details.contracts = [];
    }
    this.contrs = this.details.contracts;
  },
};
</script>

<style lang="scss" scoped>
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
  min-height: 36px;
}
.label-input-radio {
  display: block;
  height: 20px;
  margin: auto;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
input[type="number"] {
  text-align: right;
}

// .input-elem {
//   width: 200px;
// }
.stamp {
  height: 260px !important;
}
@media print {
  .print-break-after {
    break-after: page;
  }
}
</style>
